module.exports = __webpack_public_path__ + "static/media/logo-jaguarari.0375c9b2.png";